import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ReportTemplateRow } from "../reportTemplatesViewConfig";

export const ReportTemplateDescriptionCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, ReportTemplateRow, string | null>) => (
        <ViewTableCell>
            {row.original.description ? (
                <span className="text-secondary text-truncate">
                    {row.original.description}
                </span>
            ) : (
                <EmptyValue />
            )}
        </ViewTableCell>
    ),
);
